import { ApplicationRoutes } from '../constants/appRoutes';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { Layout } from '../components/layout/layout';
import { AppRoles } from '../constants/appRoles';

const adminRoles = [AppRoles.UserAdmin, AppRoles.Admin];

export const AdminRoutes: RouteItem = {
  text: 'Admin',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: adminRoles,
  layout: <Layout />,
  subItems: [
    {
      text: 'Manage Users',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.admin.users,
      allowedRoles: adminRoles,
      async lazy() {
        const component = await import('../features/userAdmin/ManageUsers');
        return { Component: component.ManageUsers };
      }
    }
  ]
};
